module.exports = __webpack_public_path__ + "img/logo.d00e0ab2.png";